import PropTypes from "prop-types";
import { useDispatch } from "react-redux";

import { Button } from "components/Button";
import { Title } from "style/components/Title.styles";
import { useNavigation } from "utils/navigate";
import { togglePurchasePlanModal } from "Layout/slice/index";
import { lockIcon } from "assets/icons";
import { LockContentBox } from "./LockModal.styles";

const LockModal = ({
  visible,
  isPublicPage = false,
  title = "UNLOCK ALL FEATURES",
  publicText = "Create an account to access all features and information",
  privateText = "Upgrade your account to access all premium features and tools",
  onHide,
}) => {
  const dispatch = useDispatch();
  const { navigateToV2Signup } = useNavigation();

  const handlePublicAction = () => {
    navigateToV2Signup();
    if (onHide) onHide();
  };

  const handlePrivateAction = () => {
    dispatch(togglePurchasePlanModal(true));
  };

  return (
    <LockContentBox visible={visible}>
      <img src={lockIcon} alt="Lock" />
      <Title>{title}</Title>
      <p>{isPublicPage ? publicText : privateText}</p>
      <Button
        className="upgrade-btn"
        onClick={isPublicPage ? handlePublicAction : handlePrivateAction}
      >
        {isPublicPage ? "Get Started" : "Upgrade now"}
      </Button>
    </LockContentBox>
  );
};

LockModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  isPublicPage: PropTypes.bool,
  title: PropTypes.string,
  publicText: PropTypes.string,
  privateText: PropTypes.string,
  onHide: PropTypes.func,
};

export default LockModal;
